/**
 * ============================================================
 * PubCard.js — Full Publication Item for Publications Page
 * ============================================================
 *
 * Props (publication):
 *   {
 *     id,
 *     title,
 *     citation,
 *     year,
 *     pubtype,       // joined from pubtypes table
 *     doiurl,
 *     pdf            // "/publication-pdfs/xxx.pdf"
 *   }
 *
 * Used in:
 *   -> Publications.js (full list)
 **/

import React from "react";
import "./css/PubCard.css";

import { pubPdf } from "../utils/mediaPaths";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function PubCard({ publication }) {
  const { title, citation, doiurl, pdf } = publication;

  // ----------------------------------------------------------
  // Determine icon + link priority
  // Priority:
  //   1. DOI URL
  //   2. Local PDF file
  // ----------------------------------------------------------
  let iconSrc = null;
  let iconLink = null;

  if (doiurl && doiurl !== "null") {
    iconSrc = "/images/doi.png";
    iconLink = doiurl;
  } else if (pdf && pdf !== "null") {
    iconSrc = "/images/pdf.png";
    iconLink = pubPdf(pdf);
  }

  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <div className="pub-card">

      {/* ----- LINKED ICON (if DOI or PDF) or PLACEHOLDER ----- */}
      {iconSrc ? (
        <a
          href={iconLink}
          target="_blank"
          rel="noopener noreferrer"
          className="pub-card-icon-link"
        >
          <img
            src={iconSrc}
            alt="Publication link icon"
            className="pub-card-icon"
          />
        </a>
      ) : (
        <div className="pub-card-icon-placeholder"></div>
      )}

      {/* ----- TEXT CONTENT ----- */}
      <div className="pub-card-text">
        <h3 className="pub-card-title">{title}</h3>

        {citation && citation !== "null" && (
          <p className="pub-card-citation">
            {citation}
          </p>
        )}
      </div>

    </div>
  );
}

export default PubCard;